import type { Payment } from "@features/membership/model/types";
import { mdiFileDocumentOutline } from "@mdi/js";
import Icon from "@mdi/react";
import { useTranslation } from "react-i18next";

function PaymentItem({ payment_item, paid_date, membership_type, refund_status, amount }: Payment) {
  const { t } = useTranslation();
  const label = t(`paymentItem_${payment_item}`);
  const centerText = `${label} ${t("invoice")}`;

  return (
    <div className="flex flex-row gap-4 items-center p-2 pr-4 border border-gray-300 rounded-4">
      <div className="flex shrink-0 items-center justify-center rounded bg-gray-100 p-[10px]">
        <Icon path={mdiFileDocumentOutline} size="20px" className="text-gray-900" />
      </div>
      <div className="flex-1 min-w-0 truncate">
        <p className="text-body3 text-gray-1000" title={centerText}>
          {centerText} {/* Day Pass는 환불 표기를 노출하지 않음 */}
          {refund_status === "COMPLETED" && membership_type !== "DAY_PASS" && (
            <span className="text-red-500">{t("refunded")}</span>
          )}
        </p>
        <div className="text-caption1 leading-[1.5] text-gray-500 mt-1">{paid_date}</div>
      </div>
      <span className="flex shrink-0 text-body2 text-gray-1000">${amount}</span>
    </div>
  );
}

export default PaymentItem;
